export default {
  install (Vue, { beidouConfig }) {
    const now = new Date()
    const day = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
    const __dc = document.createElement('script') // eslint-disable-line
    const __s = document.getElementsByTagName('script')[0] // eslint-disable-line
    const __url = `//j1.58cdn.com.cn/beidou-sdk/browser/bundle.min.js?day=${day}` // eslint-disable-line

    __dc.type = 'text/javascript'
    // __dc.async = true
    __dc.defer = false
    __dc.src = window.location.protocol + __url
    __dc.onload = function () {
      if (window.Beidou && beidouConfig) {
        window.Beidou.init(beidouConfig || {})

        const oldOnError = Vue.config.errorHandler
        Vue.config.errorHandler = function (err, vm, info) {
          // 你可以在此处，手动调用 Beidou.captureException 将错误日志上报给北斗服务器
          window.Beidou.captureException(err, info)
          if (typeof oldOnError === 'function') {
            oldOnError.call(Vue, err, vm, info)
          }
        }
      }
    }
    __s.parentNode.insertBefore(__dc, __s)
  }
}
